import { Provider } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { AppDataService } from './app-data.service';
import { BaseSiteCoreAPIMapper } from './sitecore-data-mapper/base-sitecore-api-mapper.service';
import { FormSitecoreMapperService } from './sitecore-data-mapper/form-site-core-mapper.service';
import { GridSitecoreMapperService } from './sitecore-data-mapper/grid-site-core-mapper.service';
import { GetCorePageDataService } from './sitecore-data-mapper/get-core-page-data.service';
import { BaseResolverService } from './resolver/base-data-resolver';
import { DashboardKpiService } from './dashboard-kpi.service';
// import { OktaLoginService } from './okta-login.service';
import { ChangePasswordEmailValidService } from './change-password-email-valid.service';
import { StepsService } from './steps.service';
import { UploadFileService } from './upload-file.service';
import { SummaryMapperService } from './summary-mapper.service';
import { AdditionalInsuredService } from './additional-insured.service';

// services
export * from './additional-insured.service';
export * from './steps.service';
export * from './dashboard.service';
export * from './base-data-service';
export * from './app-data.service';
export * from './dashboard-kpi.service';
export * from './sitecore-data-mapper/base-sitecore-api-mapper.service';
export * from './sitecore-data-mapper/get-core-page-data.service';
export * from './base-data-service';
// export * from './okta-login.service';
export * from './change-password-email-valid.service';

export * from './resolver/base-data-resolver';
export * from './form-build.service';
export * from './global-variables.service';
export * from './upload-file.service';
export * from './summary-mapper.service';
export * from './document.service';
export * from './billing.service';
export * from './contractors-equipment.service';
export * from './custom-login.service';
// definitions
export * from './def/get-dashboard';
export * from './def/sitecore-data-def';
export * from './def/dashboard-KPI';
export * from './def/okta-login';
export * from './def/steps';
export * from './def/upload-doc';
export * from './def/contractors';
export * from './def/custom-login';

export const DataServiceProviders: Provider[] = [
  DashboardService,
  BaseSiteCoreAPIMapper,
  FormSitecoreMapperService,
  GridSitecoreMapperService,
  GetCorePageDataService,
  BaseResolverService,
  AppDataService,
  DashboardKpiService,
  // OktaLoginService,
  ChangePasswordEmailValidService,
  StepsService,
  UploadFileService,
  SummaryMapperService,
  AdditionalInsuredService
];
export * from './sub-company.service';
export * from './def/claim-subcompany';
export * from './security-user-group.service';
export * from './sitecore-data-mapper/form-site-core-mapper.service';
export * from './sitecore-data-mapper/grid-site-core-mapper.service';
